import clsx from "clsx";
import React, { FC } from "react";

import { PaginationIndicatorDot } from "./pagination-indicator-item/pagination-indicator-dot";
import { PaginationIndicatorLine } from "./pagination-indicator-item/pagination-indicator-line";
import { colorScheme } from "./styles";
import { PaginationIndicatorColor, PaginationIndicatorVariant } from "./types";

export interface PaginationIndicatorProps {
  color: PaginationIndicatorColor;
  activeItem: number;
  totalItems: number;
  className?: string;
  onClickItem?: (i: number) => void;
  variant?: PaginationIndicatorVariant;
  align?: "center" | "left";
}

export const PaginationIndicator: FC<PaginationIndicatorProps> = ({
  color,
  totalItems,
  activeItem,
  className,
  onClickItem,
  variant = PaginationIndicatorVariant.Lines,
  align = "center",
}) => {
  const { activeItemClassName, inactiveItemClassName } = colorScheme[color];
  const IndicatorComponent =
    variant === PaginationIndicatorVariant.Lines ? PaginationIndicatorLine : PaginationIndicatorDot;
  return (
    <div
      className={clsx(
        "flex",
        align === "center" && "justify-center",
        variant === PaginationIndicatorVariant.Lines ? "gap-2" : "gap-5",
        className
      )}
    >
      {new Array(totalItems).fill(null).map((_, i) => (
        <IndicatorComponent
          isActive={i === activeItem}
          key={i}
          onClick={onClickItem ? () => onClickItem?.(i) : undefined}
          activeItemClassName={activeItemClassName}
          inactiveItemClassName={inactiveItemClassName}
        />
      ))}
    </div>
  );
};
